import { BlockText, Heading, Layout, Main } from "@nju/ui";
import { ResetPasswordForm } from "./ResetPasswordForm";

export function ResetPasswordPage() {
  return (
    <Layout>
      <Main>
        <Heading
          className="mb-4 from-tablet:mb-5"
          font="ttfirs"
          tone="neutral"
          variant="h2"
          weight="bold"
        >
          podaj swój adres e-mail
        </Heading>
        <BlockText>
          Wyślemy do Ciebie e-mail z jednorazowym linkiem do zmiany hasła. Link
          będzie aktywny 10 minut.
        </BlockText>
        <ResetPasswordForm />
      </Main>
    </Layout>
  );
}
